module.exports = __webpack_public_path__ + "img/twitch-lounge-gal-9.0cc54768.jpg";